export var TroubleshootingAndOtherPOSIA = function TroubleshootingAndOtherPOSIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return COMMON_QUESTIONS_RELATED_TO_POS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [CHECK_OUT_COMMON_QUESTIONS(strictLocalize)];
    }
  };
};
var COMMON_QUESTIONS_RELATED_TO_POS = function COMMON_QUESTIONS_RELATED_TO_POS(strictLocalize) {
  return strictLocalize({
    id: "AstyzH",
    defaultMessage: "Common questions related to POS"
  });
};
var CHECK_OUT_COMMON_QUESTIONS = function CHECK_OUT_COMMON_QUESTIONS(strictLocalize) {
  return strictLocalize({
    id: "0Y1iv5",
    defaultMessage: "Check out common questions related to POS integration at Faire in the linked article. If you have any further questions, please contact us."
  });
};